import { render, staticRenderFns } from "./PivotReport.vue?vue&type=template&id=35fc5db8&scoped=true"
import script from "./PivotReport.vue?vue&type=script&lang=js"
export * from "./PivotReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fc5db8",
  null
  
)

export default component.exports